import React, { useEffect, useRef } from 'react';
import '../styles/FloatingEmojis.css';

const EMOJI_OBJECTS = ['🎮', '👾', '🕹️', '💾', '🎲', '🚀', '💫', '⚡️', '🔥', '🌟'];

export default function FloatingEmojis() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      const container = containerRef.current;
      container.innerHTML = ''; // Clear existing emojis

      // Create emojis (doubled from 20 to 40)
      for (let i = 0; i < 40; i++) {
        const emoji = document.createElement('div');
        emoji.className = 'floating-emoji';
        emoji.textContent = EMOJI_OBJECTS[Math.floor(Math.random() * EMOJI_OBJECTS.length)];
        
        // Random vertical positions that stay within view
        const startY = Math.random() * 80 + 10; // Keep between 10% and 90% of viewport height
        const endY = Math.random() * 80 + 10;
        
        emoji.style.setProperty('--startY', `${startY}vh`);
        emoji.style.setProperty('--endY', `${endY}vh`);
        emoji.style.setProperty('--duration', `${15 + Math.random() * 10}s`); // Between 15-25s
        
        // Random size between 3 and 5rem
        emoji.style.fontSize = `${3 + Math.random() * 2}rem`;
        
        // Random delay for continuous flow
        emoji.style.animationDelay = `${Math.random() * -25}s`; // Negative delay for immediate start
        
        container.appendChild(emoji);
      }
    }

    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, []);

  return <div ref={containerRef} className="floating-emojis-container" />;
} 